/**
 * 平台交易数据
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/3/8      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
 import React from "react"
import request from "@utils/request";
 import Lang from "@components/Lang/Lang";
 import {Spin, Button} from 'antd';
 import { toFixedWithCommas} from "@utils/number-util";
 import './index.less';
 import dayjs from 'dayjs';
 
 class Index extends React.Component {
     constructor(props) {
         super(props)
         this.state = {
             loading: true,
             model:{},
             countryList:[],
             countryCode:''
         }
     }
 
     showTabCon() {
        // if (this.state.tabKey === 'auditing') {
        //     return <Auditing getAuditingLenght={(num) => {this.setState({auditingNum: num})}}></Auditing>
        // } else if (this.state.tabKey === 'audited') {
        //     return <Audited></Audited>
        // } else {
        //     return null
        // }
    }

     getData() {
         this.setState({
             loading: true
         }, () => {
 
             $.ajax({
                 url: "/service/mg/statistics/transaction-data",
                 type: "post",
                 dataType: "json",
                 contentType: "application/json",
                 data: JSON.stringify({
                     countryCode:this.state.countryCode,
                 }),
                 success: (res) => {
                     let data = {
                         loading: false,
                     };
                     if (res.success && res.valid) {
                         data = Object.assign(data, {
                             model: res.model || {},
                         });
                     }
                     this.setState(data);
                 },
                 error: () => {
                     let data = {
                         loading: false,
                     };
                     this.setState(data);
                 },
             });
         })
     }
 
     country(){
        this.setState({
            // loading:true
        } ,() => {
             request({
                url: "/service/mg/sale/po/query-transaction-service-country",
                method: "POST",
                data:{}
            }).then(res => {
                if(res.data.success && res.data.valid){
                        this.setState({
                            countryList:res.data.models,
                            countryCode:res.data.models[0].countryCode
                        },() => {
                            this.getData();
                        })
                }
            })


            // $.ajax({
            //     url: "/service/mg/sale/po/query-transaction-service-country",
            //     type: "post",
            //     dataType: "json",
            //     contentType: "application/json",
            //     data: JSON.stringify({}),
            //     success: (res) => {
            //         if(res.success && res.valid){
            //             this.setState({
            //                 countryList:res.models,
            //                 countryCode:res.models[0].countryCode
            //             },() => {
            //                 this.getData();
            //             })
            //         }
            //     },
            //     error: () => {
            //         let data = {
            //             loading: false,
            //         };
            //         this.setState(data);
            //     },
            // });
        })

     }
 
     componentDidMount() {
         this.country();
     }
 
     render() {
         const {model={},loading, countryList,countryCode} = this.state;
         const {depositStatistics={},unpayOrderStatistics={},userStatistics={},currencySymbol=''} = model;
         return (
             <div className="index__wrap mt_16 pt_16">
                 <p className='top-title mb_16'>{Lang({id: 'PingTaiJiaoYiShuJu', default: '平台交易数据'})}</p>
                 {
                     (countryList && countryList.length > 1)?<div className="select-btn__wrap">
                         {
                             countryList.map((item,index)=>{
                                 return <Button key={index} className={countryCode == item.countryCode?'active':null} onClick={(e) =>{
                                     this.setState({
                                         countryCode:item.countryCode
                                     },() => {
                                         this.getData()
                                     })
                                 }} >{item.name}</Button>
                             })
                         }
                     </div>:null
                 }
                 
                 <Spin spinning={loading}>
                     <dl>
                         <dt>{Lang({id: 'YiZhiFuDingJinDingDanTongJi', default: '已支付定金订单统计'})}</dt>
                         <dd>
                             <div className="item bg-yellow">
                                 <p>{Lang({id: 'BenYue', default: '本月'})}（{dayjs().month()+1}月）</p>
                                 <p>{toFixedWithCommas(depositStatistics.currentMonth||0,2)} {currencySymbol}</p>
                             </div>
                             <div className="item">
                                 <p>{Lang({id: 'DangJi', default: '当季'})}</p>
                                 <p>{toFixedWithCommas(depositStatistics.currentQuarter||0,2)} {currencySymbol}</p>
                             </div>
                             <div className="item">
                                 <p>{Lang({id: 'DangNian', default: '当年'})}（{dayjs().format("YYYY")}）</p>
                                 <p>{toFixedWithCommas(depositStatistics.currentYear||0,2)} {currencySymbol}</p>
                             </div>
                         </dd>
                     </dl>
                     <dl>
                         <dt>{Lang({id: 'WeiZhiFuDingDanTongJi', default: '未支付订单统计'})}</dt>
                         <dd>
                             <div className="item bg-blue">
                                 <p>{Lang({id: 'WeiFuKuanJinE', default: '未付款金额'})}</p>
                                 <p>{toFixedWithCommas(unpayOrderStatistics.unpayAmount||0,2)} {currencySymbol}</p>
                             </div>
                             <div className="item bg-blue">
                                 <p>{Lang({id: 'WeiFuKuanYongHuShu', default: '未付款用户数'})}</p>
                                 <p>{unpayOrderStatistics.unpayUser||0}</p>
                             </div>
                         </dd>
                     </dl>
                     <dl>
                         <dt>{Lang({id: 'BenYueYongHuTongJi', default: '本月用户统计'})}</dt>
                         <dd>
                             <div className="item bg-blue2">
                                 <p>{Lang({id: 'XiaDanKeHu', default: '下单客户'})}</p>
                                 <p>{userStatistics.orderUser||0}</p>
                             </div>
                             <div className="item bg-blue2">
                                 <p>{Lang({id: 'ChengJiaoXinKeHu', default: '成交新客户'})}</p>
                                 <p>{userStatistics.newOrderUser||0}</p>
                             </div>
                             <div className="item bg-blue2">
                                 <p>{Lang({id: 'ZhuCeYouXiaoKeHu', default: '注册有效客户'})}</p>
                                 <p>{userStatistics.newRegisterUser||0}</p>
                             </div>
                         </dd>
                     </dl>
                     {this.showTabCon()}
                 </Spin>
             </div>
         )
     }
 }
 
 export default Index
 

